{
  "en": {
    "audio": {
      "errors": {
        "notSupported": "Audio recording is not supported in this browser",
        "microphoneAccessError": "Cannot access microphone. Please check permissions.",
        "recordingError": "An error occurred during recording",
        "stopRecordingError": "Error stopping recording",
        "noAudioData": "No audio data recorded",
        "processingError": "Error processing recorded audio",
        "noRecordedAudio": "No recorded audio available",
        "playbackError": "Error playing audio",
        "base64ConversionError": "Error converting audio to base64",
        "fileReadError": "Error reading audio file"
      }
    }
  },
  "fr": {
    "audio": {
      "errors": {
        "notSupported": "L'enregistrement audio n'est pas pris en charge par ce navigateur",
        "microphoneAccessError": "Impossible d'accéder au microphone. Veuillez vérifier les autorisations.",
        "recordingError": "Une erreur s'est produite pendant l'enregistrement",
        "stopRecordingError": "Erreur lors de l'arrêt de l'enregistrement",
        "noAudioData": "Aucune donnée audio enregistrée",
        "processingError": "Erreur lors du traitement de l'audio enregistré",
        "noRecordedAudio": "Aucun audio enregistré disponible",
        "playbackError": "Erreur lors de la lecture audio",
        "base64ConversionError": "Erreur lors de la conversion audio en base64",
        "fileReadError": "Erreur lors de la lecture du fichier audio"
      }
    }
  },
  "nl": {
    "audio": {
      "errors": {
        "notSupported": "Audio-opname wordt niet ondersteund in deze browser",
        "microphoneAccessError": "Kan geen toegang krijgen tot microfoon. Controleer de machtigingen.",
        "recordingError": "Er is een fout opgetreden tijdens het opnemen",
        "stopRecordingError": "Fout bij het stoppen van de opname",
        "noAudioData": "Geen audio-gegevens opgenomen",
        "processingError": "Fout bij het verwerken van opgenomen audio",
        "noRecordedAudio": "Geen opgenomen audio beschikbaar",
        "playbackError": "Fout bij het afspelen van audio",
        "base64ConversionError": "Fout bij het converteren van audio naar base64",
        "fileReadError": "Fout bij het lezen van audiobestand"
      }
    }
  }
}
